
import XLSX from 'xlsx';
import { Component, Vue } from 'vue-property-decorator';
import zhCN from 'ant-design-vue/es/date-picker/locale/zh_CN';
const getUrl = require('baimahu/url-with-param');
const dateFormat = require('bmh/date-format');
const { VUE_APP_FCAPI: FCAPI } = process.env;
const header = ['用户名', '手机号'];
const _ = {
  uniq: require('lodash/uniq')
};
const API = {
  get_list: `${FCAPI}/boss/hundun/work/temporary`,
  export_err: `${FCAPI}/boss/hundun/work/temporary/export`,
  temporary_custom: `${FCAPI}/boss/hundun/work/temporary/custom`,
  edit_attribute: `${FCAPI}/boss/hundun/work/temporary/attribute`
};

function initForm() {
  return {
    title: '',
    create_time: []
  };
}

@Component
export default class TemporaryMission extends Vue {
  search_form = initForm(); // 临时搜索表单重置
  locale = zhCN;
  show_change_modal = false; //批量修改弹框
  is_loading = false;
  table_data: any = {
    //表格数据
  };
  upload_limit = 200;
  percent = 0;
  show_record = 2; //是否显示触达记录，默认显示否
  edit_mission_id = 0; //编辑任务id
  form: any;
  modal_title = '';
  input_data = [];
  file_list: any = [];
  excel_file: any;
  confirm_loading = false;
  select_row_key = []; //被选中项
  field_list: any = [];
  field_list_del: any = [];
  rules: any = {
    name: [
      { required: true, message: 'Please input Activity name', trigger: 'blur' },
      { min: 3, max: 5, message: 'Length should be 3 to 5', trigger: 'blur' }
    ]
  };
  is_top = 2;
  // 临时搜索
  async temporarySearch(page = 1) {
    this.is_loading = true;
    const start_time = this.search_form.create_time[0] ? Math.floor((this.search_form.create_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
    const end_time = this.search_form.create_time[1] ? Math.floor((this.search_form.create_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 86400 : '';
    const send_data = {
      title: this.search_form.title ? this.search_form.title : '',
      time_start: start_time,
      time_end: end_time,
      current: page,
      page: 20
    };
    const url = getUrl(API.get_list, send_data);
    const res: any = await this.$axios.get(url);
    if (res.status !== 200) {
      this.$message.error('获取失败');
      this.is_loading = false;
    }
    this.table_data = res.data.data ? res.data.data : [];
    this.table_data.detail.forEach((element: any) => {
      element.finished_status = element.finished_status == 2 ? true : false;
    });
    this.is_loading = false;
  }
  handleFieldDel(data: any, index: number) {
    if (data[index].id) {
      this.field_list_del.push(data[index]);
    }
    data.splice(index, 1);
  }
  showChangeModal() {
    this.form.resetFields();
    this.modal_title = '创建任务';
    this.show_record = 2;
    this.show_change_modal = true;
    this.confirm_loading = false;
    this.file_list = [];
    this.field_list = [];
    this.input_data = [];
    this.is_top = 2;
  }
  async getList(page = 1) {
    this.is_loading = true;
    const send_data: any = {
      current: page,
      page: 20
    };
    const url = getUrl(API.get_list, send_data);
    const res: any = await this.$axios.get(url);
    if (res.status === 200) {
      this.is_loading = false;
      this.table_data = res.data.data ? res.data.data : [];
      this.table_data.detail.forEach((element: any) => {
        element.finished_status = element.finished_status == 2 ? true : false;
      });
    }
  }
  check(record: any) {
    this.$router.push({
      path: `/hundun/mission-detail/${record.id}`,
      query: { title: record.title }
    });
  }
  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d %H:%M:%S');
  }
  created() {
    this.getList(1);
  }
  onSelectChange(select_row_key: any) {
    //选择钩子函数
    this.select_row_key = select_row_key;
  }
  paginationOption(remote: any) {
    return {
      current: +remote.current || 0,
      total: remote.total || 0,
      pageSize: remote.limit || 0,
      showTotal: () => `共${remote.total}条，每页${remote.limit}条`
    };
  }
  changePage(page: any) {
    this.getList(page.current);
  }
  handleChange(info: any) {
    if (info.fileList.length == 0) {
      this.input_data = [];
      this.file_list = [];
    } else {
      this.file_list = [info.fileList[0]];
      const arr = this.file_list[0].name.split('.');
      if (arr[arr.length - 1] !== 'xlsx' && arr[arr.length - 1] !== 'xls') {
        this.file_list = [];
        this.input_data = [];
      }
    }
  }
  beforeUpload(file: any) {
    const arr = file.name.split('.');
    if (arr[arr.length - 1] !== 'xlsx' && arr[arr.length - 1] !== 'xls') {
      this.file_list = [];
      this.input_data = [];
      this.$message.error('请上传xlsx或xls格式的文件');
      return false;
    }
    if (this.file_list.length > 0) {
      this.$message.error('最多上传一个文件，请先删除当前文件或者将文件整合在一个excel中');
      return false;
    }
  }
  //读取excel
  uploadFile(file: any) {
    const sheet2JSONOpts = {
      /** Default value for null/undefined values */
      defval: '' //给defval赋值为空的字符串
    };
    new Promise((resolve: any) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target?.result;
        this.excel_file = XLSX.read(data, { type: 'binary' }); // xlsx文件的读取方式是 BinaryString格式
        const result: any = [];
        this.excel_file.SheetNames.forEach((sheetName: any) => {
          result.push({
            SheetNames: sheetName,
            sheet: XLSX.utils.sheet_to_json(this.excel_file.Sheets[sheetName], sheet2JSONOpts)
          });
        });
        resolve(result);
      };
      reader.readAsBinaryString(file.file);
    }).then((res: any) => {
      // let obj={
      //   name:file.file.name,
      //   status:'done'
      // }
      // this.file_list.push(obj);
      this.input_data = res[0].sheet;
      const keys = Object.keys(this.input_data[0]);
      for (const item in header) {
        if (keys.indexOf(header[item]) === -1) {
          this.input_data = [];
          this.file_list = [];
          this.$message.error(`请确保导入文件中有${header[item]}字段`);
          return;
        }
      }
      let real_data: any = [];
      this.input_data.forEach((item) => {
        let obj = {
          name: item['用户名'],
          mobile: item['手机号'],
          description: item['任务备注1'],
          description2: item['任务备注2'],
          description3: item['任务备注3'],
          description4: item['任务备注4'],
          description5: item['任务备注5']
        };
        real_data.push(obj);
      });
      this.input_data = real_data;
      // console.log(Object.keys(this.input_data[0]));
      this.file_list[0].status = 'done';
      console.log(this.input_data.length);
      if (this.input_data.length > 20000) {
        this.input_data = [];
        this.file_list = [];
        this.$message.error('上传名单不能超过2w条');
        return;
      }
    });
  }
  download() {
    const header = [['用户名', '手机号', '任务备注1', '任务备注2', '任务备注3', '任务备注4', '任务备注5']];
    const sheet_header = XLSX.utils.aoa_to_sheet(header);
    const sheet = XLSX.utils.sheet_add_json(sheet_header, [], {
      skipHeader: true,
      origin: 'A2'
    });
    const wb = XLSX.utils.book_new(); //新建workbook将sheet加入进去
    XLSX.utils.book_append_sheet(wb, sheet, 'sheetName');
    XLSX.writeFile(wb, '临时任务导入模版.xlsx');
  }
  async edit(record: any) {
    const res: any = await this.$axios.get(`${API.temporary_custom}?temporary_id=${record.id}`);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    if (res.data.data) {
      this.field_list = res.data.data.map((element: any) => {
        element.options = element.options.split(',').map((elements: any) => {
          return {
            name: elements,
            is_error: false
          };
        });
        return (element = { ...element, is_error: false });
      });
    } else {
      this.field_list = [];
    }
    setTimeout(() => {
      this.form.setFieldsValue({
        mission_name: record.title,
      });
    });
    this.field_list_del = [];
    this.show_record = record.is_show_reach;
    this.edit_mission_id = record.id;
    this.show_change_modal = true;
    this.is_top = record.is_top;
    this.modal_title = '编辑任务';
  }
  //下载导入错误信息
  downloadErr(record: any) {
    const send_data = {
      temporary_id: record.id,
      is_export: 1
    };
    const url = getUrl(API.export_err, send_data);
    // window.location.href = url;
    this.$axios.get(url).then((res) => {
      if (res.data.status === 200) {
        this.$message.info(res.data.data);
      } else {
        window.location.href = url;
      }
    });
  }
  // 分页上传
  async moreUpload(start: number, name: string, is_show_reach: number) {
    console.log(start);
    console.log(name);
    console.log(is_show_reach);
    console.log(this.input_data.length);
    if (start > this.input_data.length) {
      this.percent = 100;
      // this.$message.success('上传成功');
      // this.input_data = [];
      // this.file_list = [];
      // this.show_change_modal = false;
      // this.confirm_loading = false;
      // this.percent = 0;
      // this.getList(this.table_data.current);
      return;
    }
    let request = [];
    let s = start;
    for (let i = 0; i < 5; i++) {
      const send_data = {
        title: name,
        is_show_reach: is_show_reach,
        list: this.input_data.slice(s, s + this.upload_limit)
      };
      console.log(send_data);
      if (send_data.list.length !== 0) {
        request.push(this.$axios.put(`${API.get_list}/${this.edit_mission_id}`, send_data));
      }

      s = s + this.upload_limit;
    }
    if (request.length > 0) {
      await Promise.all(request);
      console.log('测试断电');
      this.percent = Number(Number((s / this.input_data.length) * 100).toFixed(1));
      await this.moreUpload(s, name, is_show_reach);
    } else {
      return;
    }
  }
  confirmUpload() {
    for (let i = 0; i < this.field_list.length; i++) {
      console.log(this.field_list[i].name);
      if (!this.field_list[i].name) {
        this.field_list[i].is_error = true;
        console.log(this.field_list[i].is_error);
        return;
      }
      this.field_list[i].is_error = false;
      if (this.field_list[i].type === 2) {
        for (let y = 0; y < this.field_list[i].options.length; y++) {
          if (!this.field_list[i].options[y].name) {
            this.field_list[i].options[y].is_error = true;
            console.log(this.field_list[i].options[y].is_error);
            return;
          }
          this.field_list[i].options[y].is_error = false;
        }
      }
    }
    this.form.validateFields(async (err: any, values: any) => {
      if (!err) {
        // if (this.input_data.length === 0) {
        //   this.$message.error('请选择文件上传');
        //   return;
        // }
        const send_field_list = JSON.parse(JSON.stringify(this.field_list));
        send_field_list.forEach((element: any) => {
          element.options = element.options.map((item: any) => item.name).filter((item: any) => item);
        });
        if (this.modal_title === '创建任务') {
          const send_data: any = {
            title: values.mission_name,
            is_show_reach: this.show_record,
            is_top: this.is_top,
            add: send_field_list
          };
          this.confirm_loading = true;
          const res: any = await this.$axios.post(API.get_list, send_data);
          if (res.data.status !== 200) {
            this.$message.error(res.data.message);
          }
          this.edit_mission_id = res.data.data.id;
          await this.moreUpload(0, values.mission_name, this.show_record);
          // this.moreUpload(0, values.mission_name, this.show_record);
          if (res.data.status === 200) {
            this.$message.success('创建成功');
          } else {
            this.$message.error(res.data.message);
            this.confirm_loading = false;
            return;
          }
        } else {
          const send_data: any = {
            title: values.mission_name,
            is_show_reach: this.show_record,
            is_top: this.is_top,
            add: send_field_list
              .filter((item: any) => !item.id)
              .map((item: any) => {
                return { ...item, temporary_id: this.edit_mission_id };
              }),
            edit: send_field_list.filter((item: any) => item.id),
            deletes: this.field_list_del.map((item: any) => item.id)
          };
          this.confirm_loading = true;
          const res: any = await this.$axios.put(`${API.get_list}/${this.edit_mission_id}`, send_data);
          if (res.data.status !== 200) {
            this.$message.error(res.data.message);
            return;
          }
          this.confirm_loading = true;
          await this.moreUpload(0, values.mission_name, this.show_record);
        }
        console.log('怎么能结束呢');
        this.percent = 0;
        this.input_data = [];
        this.file_list = [];
        this.show_change_modal = false;
        this.confirm_loading = false;
        this.getList(this.table_data.current);
        this.show_change_modal = false;
      }
      this.show_change_modal = false;
    });
  }
  beforeCreate() {
    this.form = this.$form.createForm(this);
  }
  handleAddFieldItem() {
    this.field_list.push({
      is_error: false,
      name: '',
      options: [
        {
          name: '',
          is_error: false
        }
      ],
      type: 1
    });
  }
  handleAddFieldSubitem(item: any) {
    item.options.push({
      name: ''
    });
    console.log(item);
  }
  // 完成状态
  editAttribute(id: number, column: any, val: any) {
    this.$confirm({
      title: '操作确认?',
      content: `您确认要${column == 'finished_status' ? '修改任务的状态为已完成？' : '取消置顶该条数据？该数据将会正常排序。'}`,
      onOk: async () => {
        const send_data = {
          column: column,
          value: column == 'finished_status' ? (val ? 2 : 1) : val ? 1 : 2
        };
        const res = await this.$axios.put(`${API.edit_attribute}/${id}`, send_data);
        if (res.status == 200 && res.data.status == 200) this.$message.success('编辑成功！');
        else this.$message.error('编辑失败！');
        this.getList(1);
      },
      onCancel: () => {
        this.getList(1);
      }
    });
  }
}
